import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { useWindowSize } from '../../../../../utils/hooks';
import InfoSign from '../../../../common/InfoSign/InfoSign';
import { responsiveSizeTimesheet, timesheetsStatuses } from '../../../../../utils/constants';
import KeyValueLabel from '../../../../common/labels/KeyValueLabel/KeyValueLabel';
import ThreeDotMenu from '../../../../common/ThreeDotMenu/ThreeDotMenu';
import InfoIcon from '../../../../common/Icons/InfoIcon';
import { generalEnums } from '../../../../../utils/enums';
import colors from '../../../../../scss/colors';

const MobileHeadMenuContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '16px'
}));

const ThreeDotContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '24px'
}));

const ThreeDotItem = styled('p')(() => ({
  fontStyle: 'normal',
  fontWeight: 325,
  fontSize: '20px',
  lineHeight: '24px',
  color: colors.MEDIUM_GREY,
  cursor: 'pointer'
}));

export default function MobileHeadMenu({
  data,
  deleteHandler,
  isSectionOpen,
  copyHandler,
  isApprover,
  pageType,
  timesheetPlacementStatus,
  isInfoIcon,
  exportHandler
}) {
  const size = useWindowSize();
  const { t } = useTranslation();

  return (
    <MobileHeadMenuContainer>
      {!!isInfoIcon && (
        <InfoSign icon={<InfoIcon />}>
          <Box
            sx={{
              width: '100%',
              padding: '32px 24px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: '14px',
              backgroundColor: colors.PAGE_BACKGROUND,
              boxShadow: size.width > responsiveSizeTimesheet ? '0 4px 4px rgba(0, 0, 0, 0.25)' : 'none',
              borderRadius: '20px'
            }}
          >
            <KeyValueLabel
              oneLine
              label={isApprover ? t('dashboard.timesheet.header.contractor') : t('dashboard.timesheet.header.client')}
              value={isApprover ? `${data?.User?.FirstName} ${data?.User?.LastName}` : data?.ClientName}
            />
            <KeyValueLabel
              oneLine
              label={t('dashboard.timesheet.header.jobtitle')}
              value={data?.Placement || data?.JobTitle}
            />
            <KeyValueLabel
              oneLine
              label={t('dashboard.timesheet.header.date')}
              value={dayjs(data?.CreatedDate).format(generalEnums.DATEWITH_MMM)}
            />
            <KeyValueLabel oneLine label={t('dashboard.timesheet.header.order')} value={data?.PO || data?.PoNumber} />
            <KeyValueLabel oneLine label={t('dashboard.timesheet.header.recordn')} value={data?.RecordNo} />
          </Box>
        </InfoSign>
      )}

      {pageType === generalEnums.TIMESHEET && !isApprover && (
        <ThreeDotMenu
          menuComponent={<MoreVertOutlinedIcon sx={{ color: colors.BLACK_TXT, fontSize: '24px' }} />}
          isSwipeable="false"
        >
          <ThreeDotContainer>
            <>
              {timesheetPlacementStatus && (
                <ThreeDotItem onClick={copyHandler}>{t('dashboard.timesheets.threedot.copy')}</ThreeDotItem>
              )}
              {data.Status.Status === timesheetsStatuses(t).draft.apiStatus && (
                <ThreeDotItem onClick={deleteHandler}>
                  {isSectionOpen ? t('common.general.deletesection') : t('dashboard.timesheets.threedot.delete')}
                </ThreeDotItem>
              )}
              {data.Status.Status === timesheetsStatuses(t).processed.apiStatus && (
                <ThreeDotItem onClick={exportHandler}>{t('dashboard.timesheet.header.export', 'Export')}</ThreeDotItem>
              )}
            </>
          </ThreeDotContainer>
        </ThreeDotMenu>
      )}
      {data.Status.Status === timesheetsStatuses(t).draft.apiStatus &&
        pageType === generalEnums.EXPENSE &&
        !isApprover && (
          <ThreeDotMenu
            menuComponent={<MoreVertOutlinedIcon sx={{ color: colors.BLACK_TXT, fontSize: '24px' }} />}
            isSwipeable="false"
          >
            <ThreeDotContainer>
              <ThreeDotItem onClick={deleteHandler}>{t('dashboard.expenses.threedot.delete')}</ThreeDotItem>
            </ThreeDotContainer>
          </ThreeDotMenu>
        )}

      {pageType === generalEnums.EXPENSE &&
        data.Status.Status === timesheetsStatuses(t).processed.apiStatus &&
        !isApprover && (
          <ThreeDotMenu
            menuComponent={<MoreVertOutlinedIcon sx={{ color: colors.BLACK_TXT, fontSize: '24px' }} />}
            isSwipeable="false"
          >
            <ThreeDotItem onClick={exportHandler}>{t('dashboard.timesheet.header.export', 'Export')}</ThreeDotItem>
          </ThreeDotMenu>
        )}
    </MobileHeadMenuContainer>
  );
}
